import {
  Box,
  Card,
  CardContent,
  Container,
  Grid,
  Typography,
} from "@mui/material";
import PeopleOutlinedIcon from "@mui/icons-material/PeopleOutlined";
import LoginOutlinedIcon from "@mui/icons-material/LoginOutlined";
import SwapHorizOutlinedIcon from "@mui/icons-material/SwapHorizOutlined";
import VerifiedUserOutlinedIcon from "@mui/icons-material/VerifiedUserOutlined";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import HistoryOutlinedIcon from "@mui/icons-material/HistoryOutlined";
import TrendingUpOutlinedIcon from "@mui/icons-material/TrendingUpOutlined";
import { colors } from "../../constants/colors";
import { useNavigate } from "react-router-dom";

const metricCards = [
  {
    title: "Daily Users",
    description: "New user sign-ups for the selected day",
    icon: PeopleOutlinedIcon,
    path: "/super-admin/ops/daily-users",
  },
  {
    title: "Daily AUT",
    description: "Total investments made on the platform in the selected period",
    icon: LoginOutlinedIcon,
    path: "/super-admin/ops/aut",
  },
  {
    title: "Transactions Initiated",
    description: "Transactions started in the selected period",
    icon: SwapHorizOutlinedIcon,
    path: "/super-admin/ops/transactions-initiated",
  },
  {
    title: "KYC Initiated",
    description: "KYC flows started in the selected period",
    icon: VerifiedUserOutlinedIcon,
    path: "/super-admin/ops/kyc-initiated",
  },
  {
    title: "Family Data",
    description: "Family members added by investors in the selected period",
    icon: GroupsOutlinedIcon,
    path: "/super-admin/ops/family-data",
  },
  {
    title: "User Logins",
    description: "Investor login activity and counts for the selected period",
    icon: HistoryOutlinedIcon,
    path: "/super-admin/ops/user-logins",
  },
  {
    title: "Best / Worst Holdings",
    description: "Best and worst stock & MF performers by overall % for onboarded investors",
    icon: TrendingUpOutlinedIcon,
    path: "/super-admin/ops/best-worst-holdings",
  },
];

const SuperAdminDashboard = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="xl" sx={{ py: 3 }}>
      <Box sx={{ mb: 3 }}>
        <Typography variant="h5" sx={{ fontWeight: 700, color: colors.primary }}>
          Ops Dashboard
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
          Super-admin metrics and operational insights.
        </Typography>
      </Box>

      <Grid container spacing={3}>
        {metricCards.map((card) => {
          const Icon = card.icon;
          const isClickable = !!card.path;

          return (
            <Grid item xs={12} sm={6} md={4} key={card.title}>
              <Card
                onClick={() => isClickable && navigate(card.path)}
                sx={{
                  height: "100%",
                  border: "1px solid #e8e8e8",
                  boxShadow: "none",
                  cursor: isClickable ? "pointer" : "default",
                  transition: "all 0.3s ease-in-out",
                  "&:hover": isClickable
                    ? {
                        transform: "translateY(-4px)",
                        boxShadow: "0 12px 24px rgba(0,0,0,0.08)",
                        borderColor: colors.primary,
                      }
                    : {},
                }}
              >
                <CardContent>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      mb: 2,
                    }}
                  >
                    <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                      {card.title}
                    </Typography>
                    <Icon sx={{ color: colors.primary, fontSize: 28 }} />
                  </Box>
                  <Typography
                    variant="h4"
                    sx={{ fontWeight: 700, color: isClickable ? colors.primary : "#9e9e9e", mb: 1 }}
                  >
                    {isClickable ? "Active" : "—"}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {card.description}
                  </Typography>
                  <Typography
                    variant="caption"
                    sx={{
                      display: "inline-block",
                      mt: 2,
                      px: 1.5,
                      py: 0.5,
                      borderRadius: 1,
                      bgcolor: isClickable ? "rgba(102, 77, 229, 0.08)" : "#f5f5f5",
                      color: isClickable ? colors.primary : "text.secondary",
                      fontWeight: 600,
                    }}
                  >
                    {isClickable ? "View Details" : "Coming soon"}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          );
        })}
      </Grid>
    </Container>
  );
};

export default SuperAdminDashboard;
